import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {INickOptionsField} from '../interface/nick.i.options.field';
import {INickPrefixField} from '../interface/nick.i.prefix.field';
import {INickSearchField} from '../interface/nick.i.search.field';
import {FieldEntity} from './field.entity';
import {ModelEntity} from './model.entity';
import {EnvironmentKind} from "../enum/environment.kind";

@EntityTable('field_model_xref', 'ce4741dc-b7bb-4aff-aa1b-20655853ff0b')
export class FieldModelXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, ModelEntity, false, false, FieldRelationKind.BELONGS_TO, 'model', 'aliasId', 'modelId')
    public modelId: string;

    @JoinColumn(FieldTypeKind.GUID, FieldEntity, false, false, FieldRelationKind.BELONGS_TO, 'field', 'aliasId', 'fieldId')
    public fieldId: string;

    @Column(FieldTypeKind.DECIMAL)
    public index: number;

    @Column(FieldTypeKind.BOOLEAN)
    public hidden: boolean;

    @Column(FieldTypeKind.BOOLEAN)
    public required: boolean;

    @Column(FieldTypeKind.BOOLEAN)
    public readOnly: boolean;

    @Column(FieldTypeKind.BOOLEAN)
    public unique: boolean;

    @Column(FieldTypeKind.ANY)
    public options: INickOptionsField;

    @Column(FieldTypeKind.ANY)
    public defaultValue: any;

    @Column(FieldTypeKind.BOOLEAN)
    public autoIncrement: boolean;

    @Column(FieldTypeKind.LONG)
    public relation: FieldRelationKind;

    @Column(FieldTypeKind.STRING)
    public relationName: string;

    @Column(FieldTypeKind.STRING)
    public foreignKey: string;

    @Column(FieldTypeKind.STRING)
    public sourceKey: string;

    @Column(FieldTypeKind.STRING)
    public targetKey: string;

    @Column(FieldTypeKind.BOOLEAN)
    public constraint: boolean;

    @Column(FieldTypeKind.ANY)
    public search: INickSearchField;

    @Column(FieldTypeKind.ANY)
    public filter: any;

    @Column(FieldTypeKind.ANY)
    public prefix: INickPrefixField;

    @Column(FieldTypeKind.STRING)
    public text: string;

    @Column(FieldTypeKind.ANY)
    public calculateField: any[];

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Transient()
    public field: FieldEntity;
}
